import { inject, type Ref, provide } from 'vue';

const KEY = Symbol('modal-hotkeys-scope');

export function provideModalHotkeysScope(scope: Ref<string>) {
  return provide(KEY, scope);
}

export function injectModalHotkeysScope() {
  return inject<Ref<string>>(KEY)!;
}
